module.exports = __webpack_public_path__ + "static/media/19ESCAP47.bc04f8f0.jpg";